import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface SessionTimedOutDialogState {
  open: boolean;
}

const initialState: SessionTimedOutDialogState = {
  open: false,
};

export const sessionTimedOutDialogSlice = createSlice({
  name: "sessionTimedOutDialog",
  initialState,
  reducers: {
    setOpen: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
  },
});

export const { setOpen } = sessionTimedOutDialogSlice.actions;

export default sessionTimedOutDialogSlice.reducer;
